







import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';
import { GPageBase } from '@/mixins';

@Component({
  name: 'GCompetencyDistribution',
})
export default class GCompetencyDistribution extends Mixins(GPageBase) {
  @Prop() data: any;
  @Prop({ default: true }) isShowTargetBorder: boolean;
  @Prop({ default: '#E3A79D' }) organizationColor: string;
  @Prop({ default: 0 }) yAxisMax: number;
  @Prop() height: number;

  public chartOptions: any = {};

  private readonly xAIXS_MIN = 0;
  private readonly xAIXS_MAX = 100;
  private readonly GRID_HEIGHT = 120; //一つのグラグの高さ
  private readonly TARGET_COLOR = '#5CADFF';
  private readonly LINE_COLOR = '#ED4014';
  private splitNumber = 5;

  mounted() {
    const self: any = this;
    this.chartOptions = {
      title: { left: 'center', top: -5 },
      legend: {
        data: [],
        top: 20,
      },
      tooltip: {
        axisPointer: {
          type: 'shadow',
        },
        formatter: function(params: any) {
          if (params.data.length !== 3) {
            return;
          }
          return `${params.data[0]}~${params.data[1]} : ${params.data[2]}`;
        },
      },
      grid: { width: '75%', height: '60%', top: 50, right: 50 },
      xAxis: [{ type: 'value', name: this.$t('SCORE').toString(), min: this.xAIXS_MIN, max: this.xAIXS_MAX }],
    };

// 人数統計（組織人数のMax値:coord.x1 参照
    const countMax = Math.max.apply(null, this.data.organization.data.map((d: any) => d[2]));
    // 組織ラインデータ
    const organizationLineData = this.data.organization.data.map((d: any) => {
      return [d[0] + 10, d[2]];
    });
    // this.chartOptions.title.text = this.data.compentecy.name;

    if (countMax < 5) {
      this.splitNumber = countMax;
    }

    if (this.yAxisMax === 0) {
      this.yAxisMax = countMax;
    }

    this.chartOptions.yAxis = [
      {
        type: 'value',
        name: this.$t('NUMBER_OF_PEOPLE').toString(),
        min: 0,
        max: Math.ceil(this.yAxisMax / this.splitNumber) * this.splitNumber,
        splitNumber: this.splitNumber,
      },
    ];
    this.chartOptions.legend.data = [this.data.organization.name, this.data.target.name];

    this.chartOptions.series = [];
    if (this.isShowTargetBorder) {
      this.chartOptions.series.push({
        name: this.data.target.name,
        type: 'custom',
        renderItem: this.targetRender,
        itemStyle: { color: this.TARGET_COLOR },
        data: [{ value: [this.data.target.data, Math.ceil(this.yAxisMax / this.splitNumber) * this.splitNumber] }],
        z: 2,
      });
    }

    this.chartOptions.series.push({
      name: this.data.organization.name,
      type: 'custom',
      renderItem: this.organizationRender,
      itemStyle: { opacity: 0.7, color: this.organizationColor },
      data: this.data.organization.data,
      z: 1,
      formatter: function(data: any): string {
        return `${data}`;
      },
    });
    this.chartOptions.series.push({
      name: this.data.organization.name,
      type: 'line',
      smooth: true,
      itemStyle: { color: this.LINE_COLOR },
      data: organizationLineData,
    });
  }

  private organizationRender(_: any, api: any) {
    // 人数統計
    const count = api.value(2);
    // グラフ上の開始位置計算
    const start = api.coord([api.value(0), count]);
    // グラフサイズ計算
    const size = api.size([api.value(1) - api.value(0), count]);
    // 棒グラフ情報作成
    return {
      type: 'rect',
      shape: { x: start[0] + 1, y: start[1], width: size[0] - 1, height: size[1] },
      style: api.style(),
    };
  }

  private targetRender(params: any, api: any) {
    // 開始位置の計算
    const countMax = api.value(1);
    const start = api.coord([api.value(0), countMax]);
    //個人のグラフの幅
    const TARGET_BAR_WIDTH = 3;
    const HEIGHT = 50;

    return {
      type: 'rect',
      shape: {
        x: start[0] - TARGET_BAR_WIDTH,
        y: start[1],
        width: TARGET_BAR_WIDTH,
        height: this.height * 0.6,
      },
      style: api.style(),
    };
  }
}
